import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface SourceFilterProps {
  sources: Array<'PubMed' | 'Semantic Scholar' | 'CrossRef'>;
  selectedSources: Array<'PubMed' | 'Semantic Scholar' | 'CrossRef'>;
  onSourceChange: (source: 'PubMed' | 'Semantic Scholar' | 'CrossRef') => void;
  sourceCounts: Record<string, number>;
}

export const SourceFilter = ({ sources, selectedSources, onSourceChange, sourceCounts }: SourceFilterProps) => {
  return (
    <div className="bg-card/50 backdrop-blur-sm rounded-lg p-4 border border-border mb-6">
      <h3 className="text-sm font-medium mb-3 text-foreground">
        Filtrar por fuente
      </h3>
      <div className="flex flex-wrap gap-4">
        {sources.map((source) => (
          <div key={source} className="flex items-center space-x-2">
            <Checkbox
              id={`source-${source}`}
              checked={selectedSources.includes(source)}
              onCheckedChange={() => onSourceChange(source)}
            />
            <Label
              htmlFor={`source-${source}`}
              className="text-sm font-normal cursor-pointer flex items-center gap-1"
            >
              {source}
              <span className="text-muted-foreground text-xs">
                ({sourceCounts[source] || 0})
              </span>
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
};
